import { useState, useEffect, useRef } from 'react';
import { Routes, Route, useLocation } from "react-router-dom";
import Page from './pages/Page';
import PageNotFound from './pages/PageNotFound';
import { AnimatePresence } from "framer-motion";
import { data } from "./data/content";
// import bgmLoop from './assets/000_bgm_loop.wav';

function App() {
  const location = useLocation();
  const [isMuted, setIsMuted] = useState(true);
  // const audioRef = useRef(null);

  // useEffect(() => {
  //   if (audioRef.current) {
  //     audioRef.current.volume = 0.5;
  //     if (isMuted) {
  //       audioRef.current.pause();
  //     } else {
  //       audioRef.current.play();
  //     }
  //   }
  // }, [isMuted]);

  return (
    <>
      {/* <audio ref={audioRef} src={bgmLoop} loop /> */}
      <AnimatePresence>
        <Routes key={location.pathname} location={location}>
          {data.pages.map((page, index) => (
            <Route key={index} exact path={`${page.slug}`} element={<Page page={page} isMuted={isMuted} setIsMuted={setIsMuted} />} />
          ))}
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </AnimatePresence>
    </>
  );
}

export default App;
